module.exports = __webpack_public_path__ + "img/myProfileImage2.471e3b16.jpg";